import { ClarityType } from '../clarityValue.esm.js';

var bufferCV = function bufferCV(buffer) {
  if (buffer.length > 1000000) {
    throw new Error('Cannot construct clarity buffer that is greater than 1MB');
  }

  return {
    type: ClarityType.Buffer,
    buffer: buffer
  };
};

var bufferCVFromString = function bufferCVFromString(str) {
  return bufferCV(Buffer.from(str));
};

export { bufferCV, bufferCVFromString };
//# sourceMappingURL=bufferCV.esm.js.map
